<template>
	<div id="velocate-rental-system-app">
		<div class="rs-container container">
			<order-overview />
			<component 
				:is="view || views[viewIndex]" 
				@next="next" 
				@previous="previous" 
				@success="success" 
				@reset="reset" />
			<site-footer />
		</div>
	</div>
</template>

<script>
import OrderOverview from './components/OrderOverview.vue'
import TimeView from './routes/TimeView.vue'
import ItemView from './routes/ItemView.vue'
import CustomerView from './routes/CustomerView.vue'
import DispatchView from './routes/DispatchView.vue'
import SuccessView from './routes/SuccessView.vue'
import Footer from './components/Footer.vue'

export default {
	name: 'App',
	components: {
		OrderOverview,
		TimeView,
		ItemView,
		CustomerView,
		DispatchView,
		SuccessView,
		SiteFooter: Footer
	},
	created() {
		this.$store.commit('order/RESET')
		this.$store.dispatch('auth').then(() => {
			this.$store.dispatch('branch/findAll')
		})
	},
	methods: {
		next() {
			this.view = null
			this.viewIndex++
		},
		previous() {
			this.view = null
			this.viewIndex--
		},
		success() {
			this.view = 'SuccessView'
		},
		reset() {
			this.$store.commit('order/RESET')
			this.view = null
			this.viewIndex = 0
		}
	},
	data() {
		return {
			views: ['TimeView', 'ItemView', 'CustomerView', 'DispatchView'],
			viewIndex: 0,
			view: null
		}
	}
}
</script>
